import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'users-collaboration',
  size: 24,
  node: [
    ['path', { d: 'M12.925 3.047a9 9 0 017.616 6.11', key: '1ddf43' }],
    ['path', { d: 'M13 22a2 2 0 012-2h4a2 2 0 012 2', key: 'vzh6pw' }],
    ['path', { d: 'M3 12a2 2 0 012-2h4a2 2 0 012 2', key: 'jlrnkm' }],
    ['path', { d: 'M3.889 15.9a9 9 0 005.247 4.632', key: 'r3hf9y' }],
    ['circle', { cx: '17', cy: '14', r: '2', key: '1bjkuo' }],
    ['circle', { cx: '7', cy: '4', r: '2', key: 'ra7k3' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name UsersCollaboration
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIuOTI1IDMuMDQ3YTkgOSAwIDAxNy42MTYgNi4xMSIgLz4KICA8cGF0aCBkPSJNMTMgMjJhMiAyIDAgMDEyLTJoNGEyIDIgMCAwMTIgMiIgLz4KICA8cGF0aCBkPSJNMyAxMmEyIDIgMCAwMTItMmg0YTIgMiAwIDAxMiAyIiAvPgogIDxwYXRoIGQ9Ik0zLjg4OSAxNS45YTkgOSAwIDAwNS4yNDcgNC42MzIiIC8+CiAgPGNpcmNsZSBjeD0iMTciIGN5PSIxNCIgcj0iMiIgLz4KICA8Y2lyY2xlIGN4PSI3IiBjeT0iNCIgcj0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/users-collaboration
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const UsersCollaboration = createLucideIcon(__iconData);

export default UsersCollaboration;
